
import { Component, Vue } from 'vue-property-decorator'
import { PersonService } from '@/services'

@Component({
    name: 'interview-detail',
    components: {
    }
})
export default class extends Vue {
    private interviewId = ''
    private interview = {}
    private statusMap = {
        1: '待回复',
        2: '已同意',
        3: '已拒绝'
    }

    private created() {
        this.interviewId = this.$route.params.id
    }

    private async mounted() {
        await this.getInterview()
    }

    /** 获取采访详情 */ 
    private async getInterview() {
        const params = {
            id: +this.interviewId
        }
        const result = await PersonService.getInterview(params)
        if (result.status === 200) {
            this.interview = result.data
        }
    }   
}
